// extracted by mini-css-extract-plugin
export default {"invalid":"UsuarioEdit_invalid__G-o0I","spinnerContainer":"UsuarioEdit_spinnerContainer__6AeXT"};